














































import { Component, Vue, Prop } from "vue-property-decorator"
import AuthErrorAlert from "@/components/Auth/AuthErrorAlert.vue"
import { mapState } from "vuex"

@Component({
  components: {
    AuthErrorAlert,
  },
  computed: {
    ...mapState("Auth", {
      resetPasswordDetails: "resetPasswordDetails",
    }),
  },
})
export default class CandidateForgotPasswordReset extends Vue {
  @Prop({ default: false }) readonly autoLogin!: boolean
  isLoading = false

  errors = {}

  resetPassword() {
    this.isLoading = true
    this.$store
      .commit("Auth/SET_AUTO_LOGIN", this.autoLogin)
    this.$store
      .dispatch("Auth/candidateForgotPasswordResetPassword")
      .then(() => {
        if (this.autoLogin) {
          this.$router.push({ name: "candidate-dashboard" })
        } else {
          this.$emit("submitted")
        }
        this.isLoading = false
      })
      .catch(({ response }) => {
        this.errors = response.data.error
        this.isLoading = false
      })
  }
}
